import image1 from '@/assets/news/20211012_1.png'
import image2 from '@/assets/news/20211012_2.jpg'

export default {
  zh: {
    title: '合生基因获评“星耀榜 —— 2021中国生物医药最具创新力企业 50 强”',
    abstract: '2021年10月11日，北京合生基因科技有限公司在上海市闵行区人民政府、上海市科学技术协会主办的 BPID 2021上海（闵行）生物医药产业创新峰会上荣获“星耀榜 —— 2021中国生物医药企业最具创新力 50 强”。',
    cover: image1,
    content: `
  <p>2021年10月11日，上海市闵行区人民政府、上海市科学技术协会主办的 BPID 2021上海（闵行）生物医药产业创新峰会暨星耀榜 —— 2021中国生物医药企业最具创新力 50 强颁奖盛典在上海虹桥祥源希尔顿酒店举行。</p>
  <div style="text-align:center"><img src="${image1}"></img></div>
  <p>经医麦客推荐，多位行业专家评审筛选，北京合生基因科技有限公司（合生基因）从数百家生物医药企业中脱颖而出，以超高的人气和超强的创新实力，荣登“星耀榜 -- 2021中国生物医药企业最具创新力 50 强”！</p>
  <div style="text-align:center"><img src="${image2}"></img></div>
  <h3>关于合生基因</h3>
  <p>合生基因作为中国首家致力于合成生物技术在生物医药领域应用的高新技术企业，于 2014 年成立于中关村生命科学园。合生基因期望利用合成生物技术开发针对癌症、遗传病、传染性疾病的创新药物和治疗方法，构建基于合成生物技术的生物医药新生态。通过合理设计构建新型基因、免疫细胞和 RNA 核酸药物，提高药物研发成功率、有效性和安全性。值得关注的是，合生基因持续加码布局以合成生物技术为基础的下一代生物药物智能制造平台开发，在合成医学生物学方向处于国际领先水平。</p>
    `
  }
}
